<template>
  <div>
    <Row>
      <Button type="info" style="margin-right: 20px" @click="exportCars">导出</Button>
      <Upload :action="apiPath + '/admin/my_company/importCar'"
              ref="uploads"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-remove="handleRemove"
              :on-preview="seeImg"
              :before-upload="beforeUpload"
              :format="['xlsx']"
              :max-size="2048"
              :on-format-error="formatError"
              :on-exceeded-size="exceededSize"
              :headers="uploadHeader"
      >
        <Button icon="ios-cloud-upload-outline" type="primary">点击上传</Button>
      </Upload>
    </Row>



    <div style="font-size: large;padding: 10px;">
      车辆数量:{{cars.length}}
    </div>

    <Row>
      <Card class="content" v-for="(item,key) in cars" :key="key">
        <span class="number">{{key+1}}</span>
        <span>{{item.car_number}}</span>
      </Card>

    </Row>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import config from '@/config/base-config'
  import XLSX from 'xlsx'
  export default {
    name: "user-lists",
    components:{pageTable},
    data() {
      return {
        cars:[],
        apiPath:config.API_PATH,
        uploadHeader:{token:sessionStorage.getItem('token')}
      }
    },
    methods: {
      async getData(){
        let res = await this.$commonFun.postProxy('admin/my_company/getCarNumbers')
        this.$commonFun.dealApiResult(res,()=>{
          this.cars = res.data
        })
      },
      async exportCars(){
        this.$commonFun.postProxy('admin/my_company/getCarNumbers',{}).then((res)=>{
          this.$commonFun.dealApiResult(res,()=>{
            let cars = []
            res.data.forEach(item=>{
              cars.push([item.car_number])
            })
            let worksheet = XLSX.utils.aoa_to_sheet(cars)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`车牌.xlsx`)
          })

        })
      },
      uploadSuccess(res,file){
        this.$refs.uploads.clearFiles()
        this.$commonFun.dealApiResult(res)
        this.getData()
      },
      handleRemove (file) {
        // const fileList = this.$refs.upload.fileList;
        /*this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        this.proofs.splice(fileList.indexOf(file), 1)*/
      },
      uploadError(){
        this.$commonFun.errorTip('上传失败请重试')
      },
      formatError(){
        this.$commonFun.errorTip('文件格式为xlsx')
      },
      exceededSize(){
        this.$commonFun.errorTip('文件大小不能超过2M')
      },
      beforeUpload(){

      },
      seeImg(file){

      },
    },
    mounted() {
      this.getData()
    }


  }
</script>

<style scoped lang="less">
  .content{
    width: 150px;
    .number{
      font-size: 20px;
      color: #2d8cf0;
      margin-right: 5px;
    }
  }

</style>
